// http(s) and protocol-relative URLs only — mailto:/tel:/fragment links stay untouched so they keep
// going straight to the OS handler / stay in place instead of opening a pointless blank tab.
const WEB_URL_PREFIXES = ['http://', 'https://', '//'];
const NEW_TAB_REL = 'noopener noreferrer';

const isWebUrl = (href: string) => {
  const normalized = href.trim().toLowerCase();
  return WEB_URL_PREFIXES.some((prefix) => normalized.startsWith(prefix));
};

/**
 * Makes every web link under `root` open in a new tab. DOMPurify strips `target` from anchors, so
 * without this a click inside a rendered email body either navigates the app away (inline preview)
 * or tries to load the site inside the sandboxed email iframe, which sites refuse via
 * frame-ancestors — to the user the link simply does nothing.
 */
export function openEmailLinksInNewTab(root: ParentNode) {
  root.querySelectorAll('a[href]').forEach((anchor) => {
    if (!isWebUrl(anchor.getAttribute('href') ?? '')) {
      return;
    }
    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('rel', NEW_TAB_REL);
  });
}
